export const activeStatus = [
  { value: 'active', label: 'Active' },
  { value: 'deactive', label: 'Deactive' },
];
